import axios from '@/utils/request'

const ordersUrl = '/supernode/orders'
const orders = async (params = {}) => {
  const { data } = await axios.post(ordersUrl, params)
  return data.data
}

const myNodesUrl = '/supernode/my-nodes'
const myNodes = async (params = {}) => {
  const { data } = await axios.post(myNodesUrl, params)
  return data.data
}

const infoUrl = '/supernode/info'
const info = async (params = {}) => {
  const { data } = await axios.post(infoUrl, params)
  return data.data
}

const promotionInfoUrl = '/supernode/promotion/info'
const promotionInfo = async (params = {}) => {
  const { data } = await axios.post(promotionInfoUrl, params)
  return data.data
}

const buyUrl = '/supernode/buy'
const buy = async (params = {}) => {
  const { data } = await axios.post(buyUrl, params)
  return data.data
}

const buyIeoUrl = '/supernode/buy-ieo'
const buyIeo = async (params = {}) => {
  const { data } = await axios.post(buyIeoUrl, params)
  return data.data
}

const promotionClaimUrl = '/supernode/promotion/claim'
const promotionClaim = async (params = {}) => {
  const { data } = await axios.post(promotionClaimUrl, params)
  return data.data
}

const releaseInfoUrl = '/supernode/release/info'
const releaseInfo = async (params = {}) => {
  const { data } = await axios.get(releaseInfoUrl, { params })
  return data.data
}

const releaseClaimUrl = '/supernode/release/claim'
const releaseClaim = async (params = {}) => {
  const { data } = await axios.post(releaseClaimUrl, params)
  return data.data
}

const needLoginUrl = [ordersUrl, myNodesUrl, promotionInfoUrl, buyUrl, buyIeoUrl, promotionClaimUrl, releaseInfoUrl, releaseClaimUrl]

export default {
  needLoginUrl,
  orders,
  myNodes,
  info,
  promotionInfo,
  promotionClaim,
  buy,
  buyIeo,
  releaseInfo,
  releaseClaim,
}
